import React from 'react';
import { useWindowScroll } from 'react-use';
import SimpleFade from '~/components/Transitions/SimpleFade';
import createSvg from '~/public/static/svg/createSvg';

const ChevronTop = createSvg(props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
));

interface Props {}

const ScrollToTopFab: React.FC<Props> = () => {
  const { y: scroll } = useWindowScroll();

  const show = scroll > 600;

  return (
    <SimpleFade
      as="button"
      show={show}
      className="fixed bottom-10 right-4 z-10 rounded-full border bg-white p-3 text-black shadow-lg md:bottom-20 md:right-8"
      onClick={() => window.scrollTo?.({ top: 0, left: 0, behavior: 'smooth' })}
      title="Back to Top"
    >
      <ChevronTop />
    </SimpleFade>
  );
};

export default ScrollToTopFab;
